@if (displayToolbar) {
  <mat-toolbar class="as-toolbar mat-elevation-z4">
    <a [href]="" routerLinkActive="router-link-active">
      <mat-icon class="as-logo" svgIcon="ic-alsuper" (click)="onNavigate()"></mat-icon>
    </a>
  </mat-toolbar>
}